// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"LogoWrapper_logo_wrapper__MEGae","logo":"LogoWrapper_logo__n4uC8"};